import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {AbstractRESTService} from "./abstract.rest.service";
import {Router} from "@angular/router";

@Injectable()
export class CasBackendRESTService extends AbstractRESTService {

    constructor(http: HttpClient, router: Router) {
        super(http, environment.authUrl, router)
    }

    protected createCustomHeaders(): any {
        return {
          headers: new HttpHeaders({
            //headers: new Headers({'Authorization': 'Basic ' + new Buffer('admin' + ':' + 'admin123').toString('base64')}),
            'Authorization': 'Bearer ' +localStorage.getItem("tokenJWT"),
        })
      };
    }
}
